import { jsx, Fragment } from 'react/jsx-runtime';
import parse, { attributesToProps, domToReact } from 'html-react-parser';
import { EGDSList } from '../../list/list/index.esm.js';
import { EGDSListItem } from '../../list/list-item/index.esm.js';
import '../../spacing/types/index.esm.js';
import { EGDSSpacing } from '../../spacing/spacing/index.esm.js';
import { EGDSSpacingHr } from '../../spacing/spacing-hr/index.esm.js';
import '../../text/types/index.esm.js';
import { EGDSHeading } from '../../text/heading/index.esm.js';
import { EGDSParagraph } from '../../text/paragraph/index.esm.js';
import '../../text/subheading/index.esm.js';
import { EGDSText } from '../../text/text/index.esm.js';
import { EGDSLink } from '../../link/link/index.esm.js';
import '../../link/types/index.esm.js';
import { DisallowedElementsArray } from '../types/index.esm.js';
const EGDSUnformattedHtml = props => {
  const {
    elementsToReplace,
    htmlToParse,
    plainTextElement: PlainTextElement
  } = props;
  const parseOptions = {
    replace: domNode => {
      const {
        children,
        attribs,
        name
      } = domNode;
      const generateChildren = () => jsx(Fragment, {
        children: domToReact(children, parseOptions)
      });
      if (elementsToReplace?.hasOwnProperty(name)) {
        const Component = elementsToReplace[name];
        const attrsToProps = attributesToProps(attribs);
        return jsx(Component, {
          ...attrsToProps,
          children: generateChildren()
        });
      }
      if (DisallowedElementsArray.includes(name)) {
        return jsx(Fragment, {});
      }
    }
  };
  if (htmlToParse) {
    const elements = parse(htmlToParse, parseOptions);
    return jsx(Fragment, {
      children: PlainTextElement && elements === htmlToParse ? jsx(PlainTextElement, {
        children: elements
      }) : elements
    });
  } else if (props.children) {
    // Backwards compatible addition:
    // If children are passed in, keep old styles
    return jsx("div", {
      children: props.children
    });
  } else {
    return null;
  }
};
const headingStyle = curriedProps => {
  const HeadingComponent = props => {
    return jsx(EGDSSpacing, {
      margin: {
        blockstart: 'four'
      },
      children: jsx(EGDSHeading, {
        ...props,
        ...curriedProps,
        children: props.children || null
      })
    });
  };
  return HeadingComponent;
};
const EGDSUnformattedHtmlReplaceDefaults = {
  h1: headingStyle({
    size: 1,
    tag: 'h1'
  }),
  h2: headingStyle({
    size: 2,
    tag: 'h2'
  }),
  h3: headingStyle({
    size: 3,
    tag: 'h3'
  }),
  h4: headingStyle({
    size: 4,
    tag: 'h4'
  }),
  h5: headingStyle({
    size: 5,
    tag: 'h5'
  }),
  h6: headingStyle({
    size: 6,
    tag: 'h6'
  }),
  hr: () => jsx(EGDSSpacingHr, {}),
  li: props => jsx(EGDSListItem, {
    children: props.children || null
  }),
  ol: props => jsx(EGDSSpacing, {
    margin: {
      blockstart: 'two'
    },
    children: jsx(EGDSList, {
      type: "ordered",
      children: props.children || null
    })
  }),
  p: props => jsx(EGDSParagraph, {
    size: 2,
    children: props.children || null
  }),
  ul: props => jsx(EGDSSpacing, {
    margin: {
      blockstart: 'two'
    },
    children: jsx(EGDSList, {
      children: props.children || null
    })
  }),
  a: props => {
    const {
      children,
      href
    } = props;
    return jsx(EGDSLink, {
      children: jsx("a", {
        href: href,
        children: children
      })
    });
  }
};
EGDSUnformattedHtml.defaultProps = {
  elementsToReplace: EGDSUnformattedHtmlReplaceDefaults,
  plainTextElement: props => jsx(EGDSText, {
    size: 300,
    children: props.children || null
  })
};
export { EGDSUnformattedHtml, EGDSUnformattedHtmlReplaceDefaults };